module.exports = __webpack_public_path__ + "img/dumbbell.dcdbe483.png";